import { LangObject, Project } from "@brg/api"
import { POST_STATUS } from "shared/components/CommentsController/const/const";
import { IPost } from "shared/components/CommentsController/const/types";
import { serializeHeadText } from "shared/contexts/VoteContext";

export type HeadPracticeAdditionalInfo = {
    competitionId: string;
};

export const getCompetitionIdFromComment = (post?: IPost | null): string | undefined =>
    (post?.additionalInfo as HeadPracticeAdditionalInfo | undefined)?.competitionId;

export const getHeadTextFromComment = (post?: IPost | null): string | undefined =>
    post?.text;

export const findHeadCommentForCompetition = (
    posts: IPost[],
    competitionId?: string | null,
    accountId?: string,
): IPost | null => {
    if (!competitionId) return null;

    const matches = posts.filter(
        (post) => getCompetitionIdFromComment(post) === competitionId,
    );

    if (!matches.length) return null;

    if (accountId) {
        return matches.find((post) => post.accountId === accountId) ?? matches[0];
    }

    return matches[0];
};

export const buildForProjectHeadUpdate = (
    project: Project<'Local'>,
    headText: LangObject[],
    headAccountId?: string,
    competitionId?: string,
    existingPost?: IPost | null,
): IPost => {
    const serializedHeadText = serializeHeadText(headText);

    const { account: _account, ...existingRest } = (existingPost ?? {}) as IPost & { account?: unknown };

    return {
        ...existingRest,
        entityId: project?.projectId,
        entityType: 'headpractice_project',
        accountId: headAccountId ?? existingPost?.accountId ?? '',
        text: serializedHeadText,
        additionalInfo: { competitionId: competitionId ?? '' },
        isQu: false,
        comments: null,
        status: POST_STATUS.active,
        commentsCount: existingPost?.commentsCount ?? 0,
        parentId: null,
    };
};
import { LangObject, Project } from "@brg/api"
import { POST_STATUS } from "shared/components/CommentsController/const/const";
import { IPost } from "shared/components/CommentsController/const/types";
import { serializeHeadText } from "shared/contexts/VoteContext";

export type HeadPracticeAdditionalInfo = {
    competitionId: string;
};

export const getCompetitionIdFromComment = (post?: IPost | null): string | undefined =>
    (post?.additionalInfo as HeadPracticeAdditionalInfo | undefined)?.competitionId;

export const getHeadTextFromComment = (post?: IPost | null): string | undefined =>
    post?.text;

export const findHeadCommentForCompetition = (
    posts: IPost[],
    competitionId?: string | null,
    accountId?: string,
): IPost | null => {
    if (!competitionId) return null;

    const matches = posts.filter(
        (post) => getCompetitionIdFromComment(post) === competitionId,
    );

    if (!matches.length) return null;

    if (accountId) {
        return matches.find((post) => post.accountId === accountId) ?? matches[0];
    }

    return matches[0];
};

export const buildForProjectHeadUpdate = (
    project: Project<'Local'>,
    headText: LangObject[],
    headAccountId?: string,
    competitionId?: string,
    existingPost?: IPost | null,
): IPost => {
    const serializedHeadText = serializeHeadText(headText);

    const { account: _account, ...existingRest } = (existingPost ?? {}) as IPost & { account?: unknown };

    return {
        ...existingRest,
        entityId: project?.projectId,
        entityType: 'headpractice_project',
        accountId: headAccountId ?? existingPost?.accountId ?? '',
        text: serializedHeadText,
        additionalInfo: { competitionId: competitionId ?? '' },
        isQu: false,
        comments: null,
        status: POST_STATUS.active,
        commentsCount: existingPost?.commentsCount ?? 0,
        parentId: null,
    };
};
